var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9867 14.8491C15.8126 14.8491 15.6384 14.785 15.5009 14.6475C15.2351 14.3816 15.2351 13.9416 15.5009 13.6758L17.3617 11.815L15.5009 9.95412C15.2351 9.68829 15.2351 9.24829 15.5009 8.98246C15.7667 8.71662 16.2067 8.71662 16.4726 8.98246L18.8192 11.3291C19.0851 11.595 19.0851 12.035 18.8192 12.3008L16.4726 14.6475C16.3351 14.785 16.1609 14.8491 15.9867 14.8491Z",
    fill: "#E62E2E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2692 12.5026H8.94666C8.57082 12.5026 8.25916 12.1909 8.25916 11.8151C8.25916 11.4392 8.57082 11.1276 8.94666 11.1276H18.2692C18.645 11.1276 18.9567 11.4392 18.9567 11.8151C18.9567 12.1909 18.645 12.5026 18.2692 12.5026Z",
    fill: "#E62E2E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.78 19.7808C6.05915 19.7808 2.75916 16.4808 2.75916 11.76C2.75916 7.03914 6.05915 3.73914 10.78 3.73914C11.1558 3.73914 11.4675 4.0508 11.4675 4.42664C11.4675 4.80247 11.1558 5.11414 10.78 5.11414C6.86582 5.11414 4.13416 7.8458 4.13416 11.76C4.13416 15.6741 6.86582 18.4058 10.78 18.4058C11.1558 18.4058 11.4675 18.7175 11.4675 19.0933C11.4675 19.4691 11.1558 19.7808 10.78 19.7808Z",
    fill: "#E62E2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIcon);
export default __webpack_public_path__ + "static/media/logoutIcon.dbeb434545e0c1e4f9919fda91e0d024.svg";
export { ForwardRef as ReactComponent };